import React from 'react';
import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';

const PREFIX = 'NotFound';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  image: `${PREFIX}-image`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(4),
  },

  [`& .${classes.content}`]: {
    paddingTop: 150,
    textAlign: 'center',
  },

  [`& .${classes.image}`]: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560,
  },
}));

const NotFound = () => {
  return (
    <Root className={classes.root}>
      <Grid container justifyContent='center' spacing={4}>
        <Grid
          size={{
            lg: 6,
            xs: 12,
          }}
        >
          <div className={classes.content}>
            <Typography variant='h1'>404: The page you are looking for isn’t here</Typography>
            <Typography variant='subtitle2'>
              You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation
            </Typography>
            <img alt='Under development' className={classes.image} src='/images/undraw_page_not_found_su7k.svg' />
          </div>
        </Grid>
      </Grid>
    </Root>
  );
};

export default NotFound;
